import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  FormControl,
  FormHelperText,
  FormLabel,
  Grid,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  Tooltip,
  Typography,
  Autocomplete,
  TextField,
  Link,
} from "@mui/material";
import { Formik, useFormikContext } from "formik";
import {
  CustomFastAsyncSelect,
  CustomFastSelect,
} from "modules/Forms/components/form.legacy.component";
import { SUPPLIER_NOT_DEFINED_CODE } from "modules/PromoItems/containers/createStepOne.container";
import PromoItemsService from "modules/PromoItems/services/promoItems.service";
import { values } from "ramda";
import React from "react";
import CampaignsService from "../service/campaigns.service";
import {
  CampaignMaterialSchema,
  CreateCampaignSchema,
} from "../service/campaigns.schemas";
import {
  CreateCampaignDTO,
  CampaignState,
  CampaignShortDTO,
} from "../service/campaigns.types";
import { useMutation, useQuery } from "@tanstack/react-query";
import { InferType } from "yup";
import TextFieldWrapper from "modules/Forms/components/textFIeldWrapper.component";
import { DatePickerWrapper } from "modules/Forms/components/datePickerWrapper.component";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import SelectSupplierContact from "modules/Forms/components/selectSupplierContact.component";
import { MediaManager } from "modules/PromoItems/components/MediaManager.component";
import moment from "moment";
import { useActiveUser } from "modules/User/activeUser";
import { HelpOutline } from "@mui/icons-material";
import { useStaticData } from "modules/MasterData/service/staticData.hooks";
import { UserInteractionType } from "modules/User/service/userInteractionType";
import { UserService } from "modules/User/service/user.service";

type CreateCampaignContainerProps = {
  onClose?: () => void;
  initialData?: CreateCampaignDTO | CampaignShortDTO;
  onRefetchLogs?: () => void;
  onRefetchDraftCampaigns?: () => void;
};

export const CreateCampaignContainer = (
  props: CreateCampaignContainerProps
) => {
  const { onClose, onRefetchLogs, onRefetchDraftCampaigns } = props;
  const navigate = useNavigate();
  const currentUser = useActiveUser();
  const staticData = useStaticData();
  const isSupplier = currentUser.isEditorSupplier();

  const l3SpendCategories = Object.values(
    staticData.spendCategoriesHashMap
  ).filter((spendCat: any) => spendCat.active && spendCat.level === 3);

  const defaultSpendCategory = l3SpendCategories.find(
    (spendCat: any) => spendCat.code === "S390041"
  ) as { id: string; code: string; name: string } | undefined;

  const isCampaignActive =
    (props.initialData as CampaignShortDTO)?.state === CampaignState.Active;
  const isPendingRestrictedAboveMarketEdit =
    (
      [
        CampaignState.Pending_Market_Proc,
        CampaignState.Pending_Confirm_Price,
      ].includes((props.initialData as CampaignShortDTO)?.state) &&
      (
        currentUser.isAboveMarketUser() ||
        currentUser.isPPAAboveMarketUser() ||
        currentUser.isEditorSupplier()
      )
    );
  console.log("state:", (props.initialData as CampaignShortDTO)?.state);
  console.log("roleId:", currentUser.userSapPersonaPslOnly);
  console.log("isEditorSupplier:", currentUser.isEditorSupplier());
  console.log("isAboveMarketUser:", currentUser.isAboveMarketUser());
  console.log("isPPAAboveMarketUser:", currentUser.isPPAAboveMarketUser());
  console.log(
    "isPendingRestrictedAboveMarketEdit:",
    isPendingRestrictedAboveMarketEdit
  );
  // const initialValues: InferType<typeof CreateCampaignSchema> = {
  //   mediaFiles: [],
  //   startDate: moment().toISOString(),
  //   endDate: moment().add(3, "M").toISOString(),
  //   validTo: moment().add(5, "M").toISOString(),
  //   strategicBuyerEmailAddress: !isSupplier ? currentUser.email : "",
  //   qualityApprovers: props.initialData?.qualityApprovers || [],
  //   spendCategoryL3: props.initialData?.spendCategoryL3 || {
  //     id: parseInt(defaultSpendCategory.id),
  //     code: defaultSpendCategory.code,
  //     name: defaultSpendCategory.name,
  //   },
  //   ...(props.initialData || {}),
  // };
  const initialValues: InferType<typeof CreateCampaignSchema> = {
    mediaFiles: [],
    startDate: moment().toISOString(),
    endDate: moment().add(3, "M").toISOString(),
    validTo: moment().add(5, "M").toISOString(),
    strategicBuyerEmailAddress: !isSupplier ? currentUser.email : "",
    qualityApprovers: props.initialData?.qualityApprovers || [],
    zones: props.initialData?.zones || [],
    markets: props.initialData?.markets || [],
    companyCodes: props.initialData?.companyCodes || [],
    spendCategoryL3: props.initialData?.spendCategoryL3 || {
      id: parseInt(defaultSpendCategory.id),
      code: defaultSpendCategory.code,
      name: defaultSpendCategory.name,
    },
    ...(props.initialData || {}),
  };
  const [emailOptions, setEmailOptions] = React.useState<any[]>([]);

  const { mutateAsync: createCampaign, isPending: creatingCampaign } =
    useMutation({
      mutationKey: ["createCampaign", values],
      mutationFn: CampaignsService.createCampaign,
      onSuccess: (data) => {
        if (onRefetchDraftCampaigns) {
          onRefetchDraftCampaigns();
        }
        if (onClose) {
          onClose();
        }
        toast.success(`Campaign ${data.id} created successfully`, {
          onClick: () => {
            navigate(`/campaigns/${data.id}`);
          },
        });
      },
    });

  const { mutateAsync: updateCampaign, isPending: updatingCampaign } =
    useMutation({
      mutationKey: ["updateCampaign", values],
      mutationFn: CampaignsService.updateCampaign,
      onSuccess: (data) => {
        if (onClose) {
          onClose();
        }
        if (onRefetchLogs) {
          onRefetchLogs();
        }
        toast.success(`Campaign ${data.id} updated successfully`, {
          onClick: () => {
            navigate(`/campaigns/${data.id}`);
          },
        });
      },
      onError: (error) => {
        if (onClose) {
          onClose();
        }
      },
    });

  const { mutateAsync: uploadCampaignMedia } = useMutation<any, any, any>({
    mutationKey: ["uploadCampaignMedia"],
    mutationFn: async (data) => {
      const response = await CampaignsService.uploadCampaignMedia(data);
      return response;
    },
  });

  const { mutateAsync: deleteCampaignMedia } = useMutation<any, any, any>({
    mutationKey: ["deleteCampaignMedia"],
    mutationFn: async (fileId) => {
      await CampaignsService.deleteCampaignMedia({ fileId });
      return fileId;
    },
  });

  return (
    <Formik
      // enableReinitialize  // dont enable this, it will cause the form to reset on every render and break the creation of the campaign
      validationSchema={CreateCampaignSchema}
      initialValues={initialValues}
      onSubmit={async (values) => {
        const payload: any = {
          ...values,

          supplierCode: values.supplierCode,

          // NEW FIELD
          supplierName: values.supplierName,

          supplierContact: {
            ...values.supplierContact,
            username:
              values.supplierContact?.username || values.supplierName,
          },
        };

        if (values.id) {
          await updateCampaign(payload);
        } else {
          await createCampaign(payload);
        }
      }}
    >
      {({
        handleSubmit,
        isValid,
        errors,
        getFieldMeta,
        setValues,
        values,
        setFieldValue,
      }) => {
        return (
          <form onSubmit={handleSubmit} style={{ height: "100%" }}>
            {/* <pre>
            <code>{JSON.stringify(errors, null, 3)}</code>
          </pre> */}
            <Grid
              container
              spacing={2}
              alignItems="stretch"
              sx={{ height: "100%" }}
            >
              <Grid item sx={{ flex: "1 0 420px" }}>
                <Paper sx={{ p: 2, minHeight: "100%" }}>
                  <Typography sx={{ mb: 1 }} variant="h5">
                    Supplier
                  </Typography>
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={4}>
                      <FormLabel>Parent Vendor:</FormLabel>
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      sm={8}
                      sx={{ position: "relative" }}
                    >

                      {isSupplier ? (
                        <CustomFastSelect
                          disabled={
                            isCampaignActive || isPendingRestrictedAboveMarketEdit
                          }
                          options={currentUser.getParentSuppliers()}
                          hasError={!!getFieldMeta("supplierCode").error}
                          customDisplay={(option) =>
                            `${option.supplierId} - ${option.name}`
                          }
                          initialValue={
                            values.supplierCode
                              ? {
                                supplierId:
                                  values.supplierCode?.replace(/^0+/, "") ||
                                  values.supplierCode,
                                name: values.supplierName,
                              }
                              : null
                          }
                          onChange={(value) => {
                            let supplierCode = value?.supplierId;
                            if (supplierCode) {
                              const trimmed = supplierCode.replace(/^0+/, "");
                              supplierCode = trimmed || supplierCode; // Keep original if all zeros
                            }

                            setValues({
                              ...values,
                              supplierCode: supplierCode,
                              supplierName: value?.name,
                              supplierContact: {
                                ...values.supplierContact,
                                username: value?.name,
                              },
                            });
                          }}
                        />
                      ) : (
                        <CustomFastAsyncSelect
                          disabled={
                            isCampaignActive || isPendingRestrictedAboveMarketEdit
                          }
                          onLoad={(searchTerm) => {
                            return PromoItemsService.getPslAmdrSuppliersHierarchy(
                              {
                                searchTerm,
                              }
                            ).then((results) => {
                              results.push({
                                id: SUPPLIER_NOT_DEFINED_CODE,
                                name: "Supplier Not Defined",
                              });
                              return results;
                            });
                          }}
                          onLoadLimit={3}
                          hasError={!!getFieldMeta("supplierCode").error}
                          customDisplay={(option) =>
                            `${option.id} - ${option.name}`
                          }
                          initialValue={
                            values.supplierCode
                              ? {
                                id: values.supplierCode,
                                name: values.supplierName,
                              }
                              : null
                          }
                          onChange={(value) => {
                            if (!value) {
                              setValues({
                                ...values,
                                supplierCode: "",
                                // supplierName: "",
                              });
                              return;
                            }

                            PromoItemsService.fetchChildrenSuppliersV2({
                              locationCompanyCodes: null,
                              childrenOf: value.id,
                              parentId: value.id,
                              zones: null,
                            }).then((response) => {
                              console.log({ response });
                            });

                            setValues({
                              ...values,
                              supplierCode: value?.id,
                              supplierName: value?.name,
                              supplierContact: {
                                ...values.supplierContact,
                                username: value?.name,
                              },
                            });
                          }}
                        />
                      )}
                      {!!getFieldMeta("supplierCode").error && (
                        <FormHelperText error>
                          {getFieldMeta("supplierCode").error}
                        </FormHelperText>
                      )}
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <FormLabel>Contact Name:</FormLabel>
                    </Grid>

                    <Grid item xs={12} sm={8}>
                      <TextField
                        size="small"
                        fullWidth
                        placeholder="Enter contact name"
                        value={values.supplierContact?.username || ""}
                        onChange={(e) => {
                          setFieldValue("supplierContact.username", e.target.value);
                        }}
                        disabled={
                          isCampaignActive || isPendingRestrictedAboveMarketEdit
                        }
                      />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <FormLabel>Contact Email:</FormLabel>
                    </Grid>

                    <Grid item xs={12} sm={8}>
                      <TextField
                        size="small"
                        fullWidth
                        placeholder="Enter contact email"
                        value={values.supplierContact?.email || ""}
                        disabled={
                          isCampaignActive || isPendingRestrictedAboveMarketEdit
                        }
                        onChange={(e) => {
                          const email = e.target.value;

                          setFieldValue("supplierContact.email", email);
                        }}
                        error={
                          !!values.supplierContact?.email &&
                          !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(
                            values.supplierContact.email
                          )
                        }
                        helperText={
                          !!values.supplierContact?.email &&
                            !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(
                              values.supplierContact.email
                            )
                            ? "Please enter a valid email address"
                            : ""
                        }
                      />
                    </Grid>


                  </Grid>
                </Paper>
              </Grid>
              <Grid item sx={{ flex: "1 0 420px" }}>
                <Paper sx={{ p: 2, minHeight: "100%" }}>
                  <Typography sx={{ mb: 1 }} variant="h5">
                    Campaign
                  </Typography>
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={4}>
                      <FormLabel>Name:</FormLabel>
                    </Grid>
                    <Grid item xs={12} sm={8}>
                      <TextFieldWrapper name="name" size="small" fullWidth />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <FormLabel>Description:</FormLabel>
                    </Grid>
                    <Grid item xs={12} sm={8}>
                      <TextFieldWrapper
                        multiline
                        rows={4}
                        size="small"
                        fullWidth
                        name="description"
                      />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <FormLabel>Buyer Email:</FormLabel>
                    </Grid>
                    <Grid item xs={12} sm={8}>
                      <CustomFastAsyncSelect
                        customTooltipMessage={currentUser.userSapPersonaPslOnly === 8 ? "Enter Buyer Email" : ""}
                        onLoadLimit={currentUser.userSapPersonaPslOnly === 8 ? 10 : 4}
                        onLoad={async (searchTerm) => {
                          const result =
                            await PromoItemsService.fetchUserEmails({
                              searchTerm,
                            });
                          return result.map((v) => ({
                            value: v,
                            label: v,
                          }));
                        }}
                        initialValue={
                          values.strategicBuyerEmailAddress
                            ? {
                              value: values.strategicBuyerEmailAddress,
                              label: values.strategicBuyerEmailAddress,
                            }
                            : null
                        }
                        hasError={
                          !!getFieldMeta("strategicBuyerEmailAddress").error
                        }
                        onChange={(value) => {
                          setFieldValue(
                            "strategicBuyerEmailAddress",
                            value?.value
                          );
                        }}
                      />
                      {!!getFieldMeta("strategicBuyerEmailAddress").error && (
                        <FormHelperText error>
                          {getFieldMeta("strategicBuyerEmailAddress").error}
                        </FormHelperText>
                      )}
                    </Grid>

                    <Grid item xs={12} sm={4}>
                      <FormLabel>Quality Approvers:</FormLabel>
                    </Grid>

                    <Grid item xs={12} sm={8}>
                      <Autocomplete
                        multiple
                        freeSolo={isSupplier}
                        disabled={isPendingRestrictedAboveMarketEdit}
                        value={values.qualityApprovers || []}
                        options={!isSupplier ? emailOptions || [] : []} // no suggestions for supplier
                        onInputChange={async (event, newInputValue, reason) => {
                          if (reason !== "input") return;

                          //  Supplier should not call API
                          if (isSupplier) return;

                          if (!newInputValue || newInputValue.length < 3) {
                            setEmailOptions([]);
                            return;
                          }

                          try {
                            const result = await PromoItemsService.fetchUserEmails({
                              searchTerm: newInputValue,
                            });

                            setEmailOptions(result);
                          } catch (error) {
                            console.error("Error fetching quality approvers", error);
                            setEmailOptions([]);
                          }
                        }}
                        onChange={(event, newValue) => {
                          if (isSupplier) {
                            // ✅ validate typed emails before saving
                            const validEmails = newValue.filter((email) =>
                              /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
                            );

                            setFieldValue("qualityApprovers", validEmails);
                          } else {
                            setFieldValue("qualityApprovers", newValue);
                          }
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            size="small"
                            placeholder={
                              isSupplier
                                ? "Enter valid email(s)"
                                : "Select quality approver emails"
                            }
                            error={!!getFieldMeta("qualityApprovers").error}
                            helperText={getFieldMeta("qualityApprovers").error}
                          />
                        )}
                      />

                      <Typography variant="caption" sx={{ display: "block", mt: 1 }}>
                        <Link
                          href="https://app.powerbi.com/Redirect?action=OpenReport&appId=a49ca96a-b318-4f4d-8f48-19cc9e9756a9&reportObjectId=13045269-86ad-47ff-9df8-93d1d1380683&ctid=12a3af23-a769-4654-847f-958f3d479f4a&reportPage=a236caf5364e0006cf49&pbi_source=appShareLink&portalSessionId=83808960-2a78-41b0-9d8e-47f92d238202"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          View Quality Approvers List
                        </Link>
                      </Typography>
                    </Grid>


                    <Grid item xs={12} sm={4}>
                      <FormLabel>Start Date:</FormLabel>
                    </Grid>
                    <Grid item xs={12} sm={8}>
                      <DatePickerWrapper
                        name="startDate"
                        slotProps={{
                          textField: {
                            size: "small",
                            fullWidth: true,
                          },
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <FormLabel>End Date:</FormLabel>
                    </Grid>
                    <Grid item xs={12} sm={8}>
                      <DatePickerWrapper
                        name="endDate"
                        slotProps={{
                          textField: {
                            size: "small",
                            fullWidth: true,
                          },
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <FormLabel>Prices are valid until:</FormLabel>
                    </Grid>
                    <Grid item xs={12} sm={8}>
                      <DatePickerWrapper
                        name="validTo"
                        slotProps={{
                          textField: {
                            size: "small",
                            fullWidth: true,
                          },
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <FormLabel>Incoterms:</FormLabel>
                    </Grid>
                    <Grid item xs={12} sm={8}>
                      <Box display="flex" gap={2} alignItems={"flex-start"}>
                        <FormControl
                          fullWidth
                          size="small"
                          error={!!getFieldMeta("incoTerms").error}
                        >
                          <InputLabel id="incotermslabel">
                            {`Incoterms
                        ${!(
                                CampaignMaterialSchema.describe().fields[
                                "incoTerms"
                                ] as any
                              )?.optional
                                ? "*"
                                : ""
                              }`}
                          </InputLabel>
                          <Select
                            labelId="incotermslabel"
                            id="incoterms-select"
                            label={`Incoterms
                        ${!(
                                CampaignMaterialSchema.describe().fields[
                                "incoTerms"
                                ] as any
                              )?.optional
                                ? "*"
                                : ""
                              }`}
                            // fullWidth
                            // size="small"
                            value={values.incoTerms}
                            onChange={(e) =>
                              setFieldValue("incoTerms", e.target.value)
                            }
                          >
                            <MenuItem value={"FOB"}>FOB</MenuItem>
                            <MenuItem value={"DDP"}>DDP</MenuItem>
                          </Select>
                          {!!getFieldMeta("incoTerms").error && (
                            <FormHelperText error>
                              {getFieldMeta("incoTerms").error}
                            </FormHelperText>
                          )}
                        </FormControl>
                        <Tooltip
                          arrow
                          title={`Prices offered in DDP price includes all import formalities, fees, duties and taxes. (like import tax and tariffs).
Prices offered in FOB price does not includes all import formalities, fees, duties and taxes. (like import tax and tariffs).
Both DDP and FOB prices do not include local taxes (like IVA in Mexico, ICMS in Brazil, TVA in France, VAT in UK).`}
                        >
                          <HelpOutline sx={{ mt: 0.8, cursor: "help" }} />
                        </Tooltip>
                      </Box>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <FormLabel>Agreements:</FormLabel>
                    </Grid>
                    <Grid item xs={12} sm={8}>
                      <TextFieldWrapper
                        name="agreements"
                        fullWidth
                        size="small"
                      />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <FormLabel>Location:</FormLabel>
                    </Grid>
                    <Grid item xs={12} sm={8}>
                      <SupplierScope
                        disabled={isPendingRestrictedAboveMarketEdit}
                      />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <FormLabel>Spend Categories L3:</FormLabel>
                    </Grid>
                   
                    <Grid item xs={12} sm={8}>
                      <Box sx={{ pointerEvents: "none", opacity: 0.7 }}>
                        <CustomFastSelect
                          disabled
                          isDisabled
                          initialValue={
                            values.spendCategoryL3
                              ? {
                                value: values.spendCategoryL3.id,
                                label: `[${values.spendCategoryL3.code}] ${values.spendCategoryL3.name}`,
                              }
                              : defaultSpendCategory
                                ? {
                                  value: defaultSpendCategory.id,
                                  label: `[${defaultSpendCategory.code}] ${defaultSpendCategory.name}`,
                                }
                                : null
                          }
                          options={l3SpendCategories.map((cat: any) => ({
                            value: cat.id,
                            label: `[${cat.code}] ${cat.name}`,
                          }))}
                          onChange={() => {
                            // Intentionally left empty so no changes can be made
                          }}
                        />
                      </Box>
                    </Grid>
                    <Grid item xs={12}>
                      <MediaManager
                        error={getFieldMeta("mediaFiles").error}
                        images={
                          values.mediaFiles?.filter(
                            (file) => file.mimeType.indexOf("image/") > -1
                          ) || []
                        }
                        onUpload={(files) => {
                          UserService.logUserInteractionData(UserInteractionType.AddOWCMediaPhoto);
                          uploadCampaignMedia({
                            file: files[0],
                            campaignId: values.id,
                          })
                            .then((response) => {
                              setFieldValue(
                                "mediaFiles",
                                values.mediaFiles.concat(response)
                              );
                            })
                            .catch((err) => {
                              console.error(err);
                            });
                        }}
                        onDelete={(mediaId) => {
                          UserService.logUserInteractionData(UserInteractionType.DeleteOWCMediaPhoto);
                          deleteCampaignMedia(mediaId).then((deletedFileId) => {
                            setFieldValue(
                              "mediaFiles",
                              values.mediaFiles.filter(
                                (f) => f.fileId !== deletedFileId
                              )
                            );
                          });
                        }}
                      />
                    </Grid>
                  </Grid>
                </Paper>
              </Grid>
              

              <Grid
                item
                xs={12}
                display={"flex"}
                justifyContent={"flex-end"}
                sx={{ mt: "auto", pb: 2 }}
              >
                <Button
                  type="reset"
                  color="primary"
                  variant="outlined"
                  size="large"
                  sx={{ ml: "auto" }}
                  onClick={() => onClose()}
                >
                  Cancel
                </Button>
                <Button
                  type="submit"
                  color="primary"
                  variant="contained"
                  size="large"
                  sx={{ ml: 2 }}
                  disabled={!isValid || creatingCampaign || updatingCampaign}
                >
                  Save
                </Button>
              </Grid>
            </Grid>
          </form>
        );
      }}
    </Formik>
  );
};

const SupplierScope = ({ disabled = false }: { disabled?: boolean }) => {
  const { values, setFieldValue } = useFormikContext<any>();
  const { data, isLoading } = useQuery({
    queryKey: ["supplierScope", values.supplierCode],
    enabled: !!values.supplierCode,
    queryFn: () =>
      PromoItemsService.getAmdrSuppliersHierarchyWithScope([
        values.supplierCode,
      ]),
    initialData: [],
  });

  return isLoading ? (
    <>loading</>
  ) : (
    <CustomFastSelect
      isMulti={true}
      disabled={isLoading || disabled}
      initialValue={values.markets?.map((v) => ({
        value: v.id,
        label: v.name,
      }))}
      options={data
        ?.reduce((acc, zone) => {
          return [...acc, ...zone.markets.map((market) => market.market)];
        }, [])
        ?.map((v) => ({
          value: v.id,
          label: v.name,
        }))}
      onChange={(value) => {
        setFieldValue(
          "markets",
          value?.map((v) => ({ id: v.value, name: v.label })) || []
        );
      }}
    />
  );
};

export default CreateCampaignContainer;
